module.exports = __webpack_public_path__ + "media/images/landing/en/main@2x-d3c1b92a86eecf6874a4144a15d3cd13.webp";